module.exports = __webpack_public_path__ + "static/img/7.dcda5ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/zh/7.png
// module id = /gv5
// module chunks = 0